import { CostCenter } from 'interfaces/CostCenter';
import { RepositoryParams, api } from '..';
export type CostCenterFilters = Partial<CostCenter & RepositoryParams>;

export const list = async (params: CostCenterFilters) => {
  return api.get('/centros-custo', { params });
};

export const listAll = async () => {
  return api.get('/centros-custo/all');
};

export const create = async (params: CostCenter) => {
  return api.post('/centros-custo', { ...params });
};

export const linkUser = async (costCenterId: string, userId: string) => {
  return api.post(`/centros-custo/${costCenterId}/users/${userId}`);
};

export const unlinkUser = async (costCenterId: string, userId: string) => {
  return api.delete(`/centros-custo/${costCenterId}/users/${userId}`);
};

export const update = async (params: CostCenter) => {
  return api.patch(`/centros-custo/${params.id}`, { ...params });
};

export const retrieve = async (id: string) => {
  return api.get(`/centros-custo/${id}`);
};

export const remove = async (id: string) => {
  return api.delete(`/centros-custo/${id}`);
};
